class EastOakSlideshow extends HTMLElement {
  connectedCallback() {
    this.initAttempts = 0;
    this.init();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    delete this.dataset.initialized;
  }

  updateAutoAspectRatio(slide = null) {
    if (this.dataset.imageSize !== 'auto') return;

    const activeSlide =
      slide ||
      this.swiper?.slides?.[this.swiper.activeIndex] ||
      this.querySelector('.east-oak-slideshow__slide');

    if (!activeSlide) return;

    const desktopAspectRatio = activeSlide.dataset.desktopAspectRatio;
    const mobileAspectRatio = activeSlide.dataset.mobileAspectRatio || desktopAspectRatio;

    if (desktopAspectRatio) {
      this.style.setProperty('--slideshow-current-desktop-aspect-ratio', desktopAspectRatio);
    }

    if (mobileAspectRatio) {
      this.style.setProperty('--slideshow-current-mobile-aspect-ratio', mobileAspectRatio);
    }
  }

  init() {
    if (this.swiper || this.dataset.initialized === 'true') return;

    const swiperEl = this.querySelector('.east-oak-slideshow__swiper');
    const slides = this.querySelectorAll('.east-oak-slideshow__slide');

    this.updateAutoAspectRatio(slides[0]);

    if (!swiperEl || slides.length <= 1) {
      this.classList.add('east-oak-slideshow--single');
      return;
    }

    if (!window.Swiper) {
      this.initAttempts += 1;
      if (this.initAttempts < 20) {
        window.setTimeout(() => this.init(), 100);
      }
      return;
    }

    const controlsType = this.dataset.controlsType || 'dots';
    const transitionType = this.dataset.transitionType || 'fade_with_text';
    const autoplayDelay = Number(this.dataset.autoplayDelay || 6) * 1000;
    const effect = transitionType === 'fade' || transitionType === 'fade_with_text' ? 'fade' : 'slide';
    const autoplay =
      this.dataset.autoplay === 'true'
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false;

    const options = {
      loop: true,
      speed: 700,
      effect,
      fadeEffect: {
        crossFade: true,
      },
      autoplay,
      on: {
        init: () => this.updateAutoAspectRatio(),
        slideChange: () => this.updateAutoAspectRatio(),
      },
    };

    if (controlsType === 'filled_arrows' || controlsType === 'outline_arrows') {
      options.navigation = {
        nextEl: this.querySelector('.east-oak-slideshow__button--next'),
        prevEl: this.querySelector('.east-oak-slideshow__button--prev'),
      };
    }

    if (controlsType === 'dots' || controlsType === 'numbers') {
      options.pagination = {
        el: this.querySelector('.east-oak-slideshow__pagination'),
        clickable: true,
      };

      if (controlsType === 'numbers') {
        options.pagination.renderBullet = (index, className) =>
          `<button class="${className}" type="button">${index + 1}</button>`;
      }
    }

    this.dataset.initialized = 'true';
    this.swiper = new window.Swiper(swiperEl, options);
  }
}

if (!customElements.get('east-oak-slideshow')) {
  customElements.define('east-oak-slideshow', EastOakSlideshow);
}
